import { useExperimentContext } from "components/ExperimentProvider";
import React, { useEffect } from "react";
import {
  ExperimentFlags,
  PAGE_EXPERIMENT_PROMO_VIS_PDP
} from "@shared/utils.experimentation";
import { useExperimentViewed } from "tracking/hooks/useExperimentViewed";
import { PromotionSectionWrapper } from "./PromotionSectionWrapper";
import { withErrorBoundary } from "react-error-boundary";

const PromotionVisibilityPDPExperimentComponent = () => {
  const { getValue } = useExperimentContext();
  const trackExperimentViewed = useExperimentViewed();

  const enabledVariants = [
    PAGE_EXPERIMENT_PROMO_VIS_PDP.values.VARIANT,
    PAGE_EXPERIMENT_PROMO_VIS_PDP.values.THROWAWAY_VARIANT
  ];
  const trackedVariant = [
    PAGE_EXPERIMENT_PROMO_VIS_PDP.values.CONTROL,
    PAGE_EXPERIMENT_PROMO_VIS_PDP.values.VARIANT
  ];
  const experimentValue = getValue(
    ExperimentFlags.PAGE_EXPERIMENT_PROMO_VIS_PDP
  ) as number;

  useEffect(() => {
    if (trackedVariant.includes(experimentValue)) {
      trackExperimentViewed(
        ExperimentFlags.PAGE_EXPERIMENT_PROMO_VIS_PDP,
        experimentValue,
        experimentValue === 1 ? "show" : "hidden"
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [experimentValue]);

  const showPromoSection = enabledVariants.includes(experimentValue);

  if (showPromoSection) {
    return <PromotionSectionWrapper />;
  } else {
    return null;
  }
};

export const PromotionVisibilityPDPExperiment = withErrorBoundary(
  PromotionVisibilityPDPExperimentComponent,
  {
    fallback: <></>,
    onError(error) {
      console.warn("Error rendering PromotionVisibilityPDPExperiment:", error);
    }
  }
);
